import {useAuthStore} from "@/stores/auth";
import Cookies from 'js-cookie'
import {api} from "@/modules/api";
import {toast} from "vue3-toastify";

export const cart = {
    getStore () {
        return useAuthStore()
    },
    async addProduct (product) {
        const store = this.getStore()
        let cart
        if (store.isConnected) {
            cart = await api.cart.addProduct(product.id, 1)
            store.setCart(cart.cart)
        } else {
            let cart = JSON.parse(Cookies.get('cart'))
            if (!cart) {
                cart = []
            }
            cart.productsCart.push(product)
            Cookies.set('cart', JSON.stringify(cart))
        }
        toast('Produit ajouté à votre panier !')
    },
    async getCart () {
        const store = this.getStore()
        let cartUser
        if (store.isConnected) {
            cartUser = await api.cart.get()
        } else {
            cartUser = JSON.parse(Cookies.get('cart'))
        }

        store.setCart(cartUser)
    },
    async removeProduct (product) {
        const store = this.getStore()
        const cart = store.getCart
        const index = cart.productsCart.findIndex(obj => obj.id === product.id)
        if (store.isConnected) {
            const newCart = await api.cart.deleteProduct(product.id)
            store.setCart(newCart.cart)
        } else {
            store.deleteCart(index)
            Cookies.set('cart', JSON.stringify(store.getCart))
        }
        toast('Produit retiré de votre panier !')
    }

}